"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
// Using the passed actionListRef in a stateful way
// is somewhat complicated, so here's a hook to simplify that work
const useActionListRef = () => {
  const actionListRef = (0, _react.useRef)();
  const [editing, setEditing] = (0, _react.useState)();
  const passedRef = (0, _react.useCallback)(node => {
    // All functions must be present on here
    actionListRef.current = node;
    if (node !== null && node !== void 0 && node.editing) {
      setEditing(node.editing);
    } else {
      setEditing();
    }
  }, []);

  // We don't need this for actionListRef, but it serves as an example for building a stateful ref object (sans functions)
  const refState = (0, _react.useMemo)(() => ({
    editing
  }), [editing]);
  return [refState,
  // This is a state containing up to date "editing" state from within ActionList
  actionListRef,
  // This is the ref which will contain the create function
  passedRef // This is the ref to pass to ActionList
  ];
};
var _default = exports.default = useActionListRef;